import { faTruckLoading } from "@fortawesome/free-solid-svg-icons";
import { wait } from "@testing-library/user-event/dist/utils";
import { useEffect, useState, Component } from "react"
import CompanyCard from "../items/CompanyCard";
import CompanyRow from "../items/CompanyRow";
import UserRow from "../items/UserRow"

class MyCompanies extends Component {

    constructor(props) {
        super(props);

        this.state = {
            companies: []
        }
    }

    componentDidUpdate() {
        disp()
    }

    componentDidMount() {
        fetch("http://localhost:8080/api/company")
            .then(res => res.json())
            .then((data) => {
                this.setState({ companies: data })
            })
            .catch(console.log)
    }


    render() {


        if (this.state.companies == 0)
            return (
                <div className="container-fluid px-4 mt-4">
                    <div className="col">

                        <span className="">Loading...</span>
                        <div className="spinner-border hidden text-light" role="status"></div>
                    </div>
                </div>
            )
        else
            return (

                <div className="container px-4 mt-4">
                    <div className="row">

                        <div className="col mb-2">
                            <h2>My Companies</h2>
                        </div>


                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4  row-cols-xl-5">

                        {this.state.companies.map(company => (
                            <CompanyCard
                                key={company.guid}
                                company={company} />

                        ))}
                    </div>
                </div>

            )
    }
}

function disp() {
    const event = new Event('rendered')
    document.dispatchEvent(event)


}

export default MyCompanies